import * as React from "react";
import {
  Modal,
  Paper,
  Box,
  Grid,
  TextField,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
} from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import axios from "axios";
import ModalHeader from "../../modals/ModalHeader";
import ModalFooter from "../../modals/ModalFooter";
import AuthContext from "../../store/AuthContext";
import { get, postJsonData } from "../../network/ApiController";
import ApiEndpoints from "../../network/ApiEndPoints";
import { apiErrorToast, okSuccessToast } from "../../utils/ToastUtil";
import AddCircleOutlineOutlinedIcon from "@mui/icons-material/AddCircleOutlineOutlined";
import useCommonContext from "../../store/CommonContext";
import CameraAltIcon from "@mui/icons-material/CameraAlt";
import CloseIcon from "@mui/icons-material/Close";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "50%",
  bgcolor: "background.paper",
  boxShadow: 24,
  fontFamily: "Poppins",
  height: "max-content",
  overflowY: "auto",
  p: 2,
};

const ScheduleRoaster = ({ title, open, onClose, refresh }) => {
  const { refreshUser } = useCommonContext();
  const authCtx = React.useContext(AuthContext);
  const [request, setRequest] = React.useState(false);

  const [users, setUsers] = React.useState([]);
  const [attendanceData, setAttendanceData] = React.useState({
    in_time: "",
    out_time: "",
    id: "",
  });

  const getUsers = () => {
    get(
      ApiEndpoints.GET_USERS_FOR_BACKEND,
      "",
      setRequest,
      (res) => {
        if (res.data) {
          setUsers(res.data);
        }
      },
      (error) => {
        console.error("API Error:", error);
        apiErrorToast(error);
      }
    );
  };

  React.useEffect(() => {
    getUsers();
  }, []);

  const handleClose = () => {
    onClose();
  };

  const formatToHMS = (value) => {
    const parts = value.split(":");
    return parts.length === 2 ? `${value}:00` : value;
  };

  const handleTimeChange = (e) => {
    const { name, value } = e.target;
    setAttendanceData((prev) => ({
      ...prev,
      [name]: formatToHMS(value),
    }));
  };

  const handleUserSelect = (e) => {
    const selectedUserId = e.target.value;
    const selectedUser = users.find((u) => u.id === selectedUserId);

    setAttendanceData({
      id: selectedUser.id,
      in_time: selectedUser.in_time || "09:45:00",
      out_time: selectedUser.out_time || "18:00:00",
    });
  };

  const handleSubmit = () => {
    const formData = new FormData();
    formData.append("in_time", attendanceData.in_time);
    formData.append("out_time", attendanceData.out_time);
    formData.append("id", attendanceData.id);

    postJsonData(
      ApiEndpoints.SCHEDULE_ROASTER,
      formData,
      setRequest,
      (res) => {
        if (refresh) refresh();
        refreshUser();
        okSuccessToast(res.data.message);
        handleClose();
      },
      (err) => {
        if (refresh) refresh();
        apiErrorToast(err);
      }
    );
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="SCHEDULE-modal-title"
      aria-describedby="SCHEDULE-modal-description"
      disablePortal
      disableEnforceFocus
      disableAutoFocus
    >
      <Paper sx={style}>
        <ModalHeader title="Change Schedule" handleClose={handleClose} />

        <Box sx={{ mt: 2, mb: 3 }}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <FormControl fullWidth>
                <InputLabel id="user-select-label">Select User</InputLabel>
                <Select
                  labelId="user-select-label"
                  value={attendanceData.id}
                  onChange={handleUserSelect}
                  label="Select User"
                >
                  {users.map((user) => (
                    <MenuItem key={user.id} value={user.id}>
                      {user.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={6}>
              <TextField
                fullWidth
                label="In Time"
                type="time"
                name="in_time"
                value={attendanceData.in_time}
                onChange={handleTimeChange}
                InputLabelProps={{ shrink: true }}
                inputProps={{ step: 300 }}
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                fullWidth
                label="Out Time"
                type="time"
                name="out_time"
                value={attendanceData.out_time}
                onChange={handleTimeChange}
                InputLabelProps={{ shrink: true }}
                inputProps={{ step: 300 }}
              />
            </Grid>
          </Grid>
        </Box>

        <ModalFooter btn="Submit" onClick={handleSubmit} />
      </Paper>
    </Modal>
  );
};
export default ScheduleRoaster;
